import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['from', 'to', 'fromInput', 'toInput']

  change(event) {
    const value = event.target.value // Format: "2025-01-01/2025-01-31"
    if (value) {
      const [from, to] = value.split('/')
      this.fromTarget.value = from
      this.toTarget.value = to
      this.element.closest('form').requestSubmit()
    }
  }

  updateFrom(event) {
    if (this.hasFromTarget) {
      this.fromTarget.value = event.target.value
    }
  }

  updateTo(event) {
    if (this.hasToTarget) {
      this.toTarget.value = event.target.value
    }
  }
}
